function findByText(text, exact = false) {
	const els = document.querySelectorAll('span, p, label, h6, h5, h4, .MuiTypography-root')
	for (const el of els) {
		const content = el.textContent.trim().toLowerCase()
		if (exact ? content === text.toLowerCase() : content.includes(text.toLowerCase())) {
			return el
		}
	}
	return null
}

function findTableColumn(headerText) {
	const headers = document.querySelectorAll('th, [class*="MUIDataTableHeadCell"]')
	for (const h of headers) {
		if (h.textContent.trim().toLowerCase().includes(headerText.toLowerCase())) {
			return h
		}
	}
	return null
}

const ES = navigator.language?.startsWith('es')

export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'boxes-stacked',
		title: ES ? 'Bienvenido a Exportaciones Agrupadas' : 'Welcome to Grouped Exports',
		description: ES
			? 'Exportaciones Agrupadas consolida los archivos de exportacion de tus informes en una unica vista. Consulta que exportaciones se han generado, descargalas y fuerza la re-exportacion cuando sea necesario.'
			: 'Grouped Exports consolidates your report export files into a single view. Track which exports have been generated, download them, and force re-export when needed.',
	},
	{
		type: 'field',
		findTarget: () => {
			const label = findByText('Chose a date range') || findByText('date range')
			if (label) return label.closest('.MuiFormControl-root') || label.closest('[class*="DateRangePicker"]') || label.parentElement
			const inputs = document.querySelectorAll('input[type="text"]')
			for (const input of inputs) {
				const parent = input.closest('.MuiFormControl-root')
				if (parent && parent.querySelector('label')?.textContent.toLowerCase().includes('date')) return parent
			}
			return null
		},
		icon: 'calendar-range',
		title: ES ? 'Filtro de Rango de Fechas' : 'Date Range Filter',
		description: ES
			? 'Filtra las exportaciones por rango de fechas. Usa el selector de fechas para elegir una fecha de inicio y fin, o selecciona entre los rangos predefinidos (Hoy, Ultimos 7 dias, Ultimos 30 dias, etc.). La tabla se actualiza automaticamente al cambiar el rango.'
			: 'Filter exports by date range. Use the date picker to select a start and end date, or choose from the preset ranges (Today, Last 7 days, Last 30 days, etc.). The table updates automatically when you change the range.',
		example: ES
			? 'Predefinidos: Hoy | Ultimos 7 dias | Ultimos 30 dias | Personalizado'
			: 'Presets: Today | Last 7 days | Last 30 days | Custom',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Grouped Exports List')
			if (el) {
				const card = el.closest('.MuiPaper-root') || el.closest('.MuiCard-root')
				if (card) return card
			}
			return document.querySelector('.MuiTable-root')?.closest('.MuiPaper-root')
		},
		icon: 'table-cells',
		title: ES ? 'Tabla de Exportaciones' : 'Exports Table',
		description: ES
			? 'La tabla principal con todas las exportaciones agrupadas del rango de fechas seleccionado. Cada fila representa un archivo de exportacion agrupado con datos de uno o mas informes. Puedes ordenar, filtrar y seleccionar varias filas.'
			: 'The main table listing all grouped exports for the selected date range. Each row represents a grouped export file containing data from one or more reports. You can sort, filter, and select multiple rows.',
	},
	{
		type: 'field',
		findTarget: () => findTableColumn('File Name') || findTableColumn('file'),
		icon: 'file',
		title: ES ? 'Nombre del Archivo' : 'File Name',
		description: ES
			? 'El nombre del archivo de exportacion agrupado. Este es el archivo consolidado que contiene datos de precios de todos los informes dentro del grupo. Usa la busqueda para encontrar archivos especificos rapidamente.'
			: 'The name of the grouped export file. This is the consolidated file that contains pricing data from all reports within the group. Use the search to quickly find specific files.',
	},
	{
		type: 'field',
		findTarget: () => findTableColumn('Creation Date') || findTableColumn('creation'),
		icon: 'calendar-plus',
		title: ES ? 'Fecha de Creacion' : 'Creation Date',
		description: ES
			? 'Cuando se creo el grupo de exportacion. Esta es la marca de tiempo de cuando el sistema comenzo a consolidar los datos de los informes en este archivo agrupado.'
			: 'When the export group was created. This is the timestamp of when the system started consolidating report data into this grouped file.',
	},
	{
		type: 'field',
		findTarget: () => findTableColumn('Export Date') || findTableColumn('export date'),
		icon: 'calendar-check',
		title: ES ? 'Fecha de Exportacion' : 'Export Date',
		description: ES
			? 'Cuando el archivo de exportacion se genero correctamente y quedo disponible para descargar. Si esta vacio, la exportacion aun no se ha procesado.'
			: 'When the export file was successfully generated and made available for download. If empty, the export has not been processed yet.',
	},
	{
		type: 'field',
		findTarget: () => findTableColumn('Exported'),
		icon: 'square-check',
		title: ES ? 'Estado de Exportacion' : 'Export Status',
		description: ES
			? 'Muestra si el archivo ha sido exportado. Una marca verde significa que el archivo esta listo para descargar. Una X roja significa que aun no se ha exportado — puedes forzar la exportacion usando la barra de seleccion multiple.'
			: 'Shows whether the file has been exported. A green checkmark means the file is ready for download. A red X means it hasn\'t been exported yet — you can force the export using the multi-select toolbar.',
		example: ES
			? 'Verde ✓ = Exportado | Rojo ✗ = No exportado'
			: 'Green ✓ = Exported | Red ✗ = Not exported',
	},
	{
		type: 'field',
		findTarget: () => findTableColumn('Info'),
		icon: 'circle-info',
		title: ES ? 'Info y Descarga' : 'Info & Download',
		description: ES
			? 'Dos acciones por fila: Info abre un modal mostrando todos los informes individuales incluidos en este grupo (con detalles de oficinas y URLs de exportacion). Descargar abre el archivo de exportacion agrupado directamente en una nueva pestana.'
			: 'Two actions per row: Info opens a modal showing all individual reports included in this group (with office details and export URLs). Download opens the grouped export file directly in a new tab.',
		example: ES
			? 'Info = Ver informes del grupo | Descargar = Obtener archivo'
			: 'Info = View reports in group | Download = Get file',
	},
	{
		type: 'field',
		findTarget: () => {
			const checkboxes = document.querySelectorAll('th .MuiCheckbox-root, th input[type="checkbox"]')
			if (checkboxes.length) return checkboxes[0].closest('th')
			return null
		},
		icon: 'cloud-arrow-up',
		title: ES ? 'Forzar Exportacion' : 'Force Export',
		description: ES
			? 'Selecciona varias filas usando las casillas de verificacion, luego haz clic en "Forzar exportacion multiple de archivos" en la barra de herramientas para regenerar las exportaciones. Solo se procesaran los archivos que aun no se han exportado — los ya exportados se omiten.'
			: 'Select multiple rows using checkboxes, then click "Force multiple file exports" in the toolbar to re-generate exports. Only files that haven\'t been exported yet will be processed — already exported files are skipped.',
		example: ES
			? 'Selecciona filas no exportadas → Boton Forzar Exportacion'
			: 'Select not-exported rows → Force Export button',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo Listo!' : "You're All Set!",
		description: ES
			? 'Usa el filtro de rango de fechas para encontrar exportaciones especificas, haz clic en Info para ver que informes estan incluidos en cada grupo, y fuerza la exportacion de archivos pendientes cuando lo necesites.'
			: 'Use the date range filter to find specific exports, click Info to see which reports are included in each group, and force-export any pending files when needed.',
	},
]
